import React from 'react'
import '../../../css/pages/form.css'

const SearchForm = ({children, fields, onSearch, onSave}) => (
  <form onSubmit={e => e.preventDefault()}>
    {children}
    {fields && (
      <div className="form-group">
        {/*<button
          className="btn btn-primary btn-rounded mr-2"
          type="submit"
          onClick={onSearch}>
          Preview
        </button>*/}
        {/*<button
          className="btn btn-primary btn-rounded"
          type="submit"
          onClick={onSave}>
          Save
        </button>*/}
      </div>
    )}
  </form>
)

export default SearchForm
